document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.index_big_top_slider', {
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: true
    })
})
